export const home = {
    title: 'ホーム',

    leftTitle: 'システム情報',
    updateInfo: '更新情報',
    copyMsg: 'チャートがクリップボードにコピーされました!',
    labelArrayOverFlowMsg: '最大5つのラベルまで表示可能です'
}
